class UnresolvedLedgerAccountErrorCell extends UITableViewCell
{
    private targetLabel:MUILabel = null;
    private accountDropdown:MUIButton = null;

    _target:UnresolvedLedgerAccountTarget = null;

    awakeFromHTML()
    {
        this.targetLabel  = MUIOutlet(this, "target-lbl",  "MUILabel");

        this.accountDropdown = MUIOutlet(this, "account-dd", "MUIButton");
        if (this.accountDropdown) this.accountDropdown.setAction(this, function(this:UnresolvedLedgerAccountErrorCell){
            if (this._target == null || this._target.targetEntity == null) return;
            AppHelper.sharedInstance().showSelectLedgerAccountViewControllerFromView(
                this.accountDropdown, this._target.chosenAccount, null, false, null, this, this.updateLedgerAccount
            );
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set target(target:UnresolvedLedgerAccountTarget) {
        this._target = target;
        if (this.targetLabel) this.targetLabel.text = target?.targetLabel ?? "";
        if (this.accountDropdown) {
            this.accountDropdown.title = target?.chosenAccount?.name ?? MIOLocalizeString("SELECT_LEDGER_ACCOUNT", "SELECT LEDGER ACCOUNT");
            this.accountDropdown.setEnabled( target != null && target.targetEntity != null );
        }
    }

    private updateLedgerAccount(controller, account:LedgerAccount) {
        if (this._target == null) return;
        this._target.chosenAccount = account;
        if (this.accountDropdown) this.accountDropdown.title = account?.name;
    }
}
